import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SubstanceCodeNameEntity } from "../../../Data/MedicinalProductData/SubstanceCodeNameEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceCodeName extends BaseNode {

    constructor(injector: Injector, model: any, parent:any) {

        super(injector,
            new SubstanceCodeNameEntity(injector, model),
            `${model.substancename} 
            - ${injector.get(LookupGetService).retrieveValueFromCache('substancenameorcode', model.iscode)}`);

        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    public getListItem(): any[] {
        return [
            this.data.model.substancename,
            this.ioc!.get(LookupGetService).retrieveValueFromCache('substancenameorcode', this.data.model.iscode)
        ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeSubstanceCodeName = new TreeNodeSubstanceCodeName(this.ioc!, this.data.model, newParent);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode;
    } 

}